import { Component } from '@angular/core';
import {
  CmsBannerCarouselComponent,
  CmsService,
  CmsBannerCarouselComponent as model,
} from '@spartacus/core';
import { BannerCarouselComponent, CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';


@Component({
    templateUrl: './uig-banner-carousel.component.html',
    standalone: false
})
export class UigBannerCarouselComponent extends BannerCarouselComponent {
  
  data$: Observable<CmsBannerCarouselComponent> = this._componentData.data$;

  constructor(
    componentData: CmsComponentData<model>,
    cmsService: CmsService,
    private _componentData: CmsComponentData<model>,
  ) {
    super(componentData, cmsService);
  }

}
